import './link-list.scss';

import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { NavigationProps } from '@sola/schema/lib/schema.ts';

type LinkListProps = {
  item: NavigationProps;
  usePadding?: boolean;
  useHover?: boolean;
  variant?: 'navigation' | 'menu';
};

export const LinkList: React.FC<LinkListProps> = ({
  item,
  usePadding = false,
  useHover = false,
  variant = 'menu',
}) => {
  const listHasIcon = item?.items?.some((i) => Boolean(i.icon));

  return (
    <ul className={cn('LinkList flex flex-col', `LinkList--${variant}`)}>
      {item.items?.map((i) => {
        if (i.renderOverride) {
          return (
            <li key={i?.title} className="flex gap-snug-xl label items-center">
              {i.renderOverride}
            </li>
          );
        }
        return (
          <li key={i?.title} className="flex gap-snug-xl label items-center">
            {/* TODO: items could override the color, or we keep it static */}
            <LinkStyle size="sm" purpose="neutral" noUnderline>
              <Link
                href={i?.link || '#'}
                target={i?.target}
                title={i?.title}
                className={cn(
                  'LinkList__menu-link w-full label-neutral flex gap-snug-xl',
                  {
                    'LinkList__menu-link--hover': useHover,
                    'justify-between items-center': variant !== 'menu',
                  },
                )}
              >
                <div
                  className={cn('flex', {
                    'gap-comfy-xs': variant === 'menu',
                    'gap-snug-xl w-full': variant !== 'menu',
                  })}
                >
                  {i?.icon && (
                    <ArkIcon iconName={i?.icon} className="LinkList__icon" />
                  )}

                  {usePadding && !listHasIcon && (
                    <span className="LinkList__icon" />
                  )}

                  <span className="LinkList__text label flex gap-snug-xl items-center">
                    {i?.title}
                  </span>
                </div>

                {i.badge?.text && (
                  <Badge
                    label={i.badge?.text}
                    color={i.badge?.color}
                    size="sm"
                  />
                )}
              </Link>
            </LinkStyle>
          </li>
        );
      })}
    </ul>
  );
};
